import { createRoot } from 'react-dom/client';
import { Analytics } from '@vercel/analytics/react';
import { initSentry } from './lib/sentry';
import App from './App.tsx';
import { ConfirmProvider } from '@/components/ConfirmProvider';
import './index.css';
import { installNativeKeyboardGuard } from '@/lib/keyboard-guard';
import { installNativeViewportLock } from '@/lib/viewport-lock';
import { installServiceWorkerUpdater } from '@/lib/sw-update';

// Initialiser Sentry AVANT le rendu React
initSentry();

// APK Sunmi : aucun champ ne prend le focus (donc le clavier) sans geste utilisateur
installNativeKeyboardGuard();
// APK Sunmi : échelle figée à 1, pincement interdit (caisse « tout en gros »)
installNativeViewportLock();
// Service worker : suit les déploiements, recharge quand la caisse est inactive
void installServiceWorkerUpdater();

createRoot(document.getElementById('root')!).render(
  <>
    <ConfirmProvider>
      <App />
    </ConfirmProvider>
    <Analytics />
  </>,
);
